import React,{useState} from 'react'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import GlobalStyles from '../../Theme/AppTheme'
import realtimeDB from '../../Utils/api';
import styled from "styled-components";
import { Tooltip } from '@material-ui/core';
import ToolTipCustom from '../ToolTipCustom';
import axios from "axios";

const ContainerImage=styled.div`
justify-content:center;
display:flex;`;

const ContainerButtons=styled.div`
background-color:white;
opacity:0.5;
height:min-content;
margin-top:10px;
margin-left:-34px;
display:flex;`;

const ImagenCarta = ({imagen,noche=false,editando,Path}) => 
{
    const {id,data}=imagen;
    const [ImagenHover, setImagenHover] = useState(false);

    const changeStatusImagenHover=()=> setImagenHover(!ImagenHover);

    const BotonEliminar=()=>
    {
        const handleDelete=async ()=>
        {
            // const NombreImagen=String(data.source).replace("https://apibaumlanus.xyz/","");
            // await axios.delete(`https://apibaumlanus.xyz/imagen/${NombreImagen}`);
            await realtimeDB.ref(Path).child(id).remove();
        }
        
        return <ContainerButtons>
            <ToolTipCustom text="Eliminar"placement="right-start">
            <DeleteOutlineIcon style={GlobalStyles.Icon} onClick={async () =>  handleDelete()}/>
            </ToolTipCustom>
        </ContainerButtons>
    }

    return <ContainerImage  onPointerEnter={changeStatusImagenHover} onPointerLeave={changeStatusImagenHover}>
        <img src={data.source} style={GlobalStyles.ImageCartaConfiguracion}/>
         {!editando &&  <BotonEliminar/>}
    </ContainerImage>
}

export default ImagenCarta
